/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signin_Sso_ButtonInputs */

const en_signin_sso_button = /** @type {(inputs: Signin_Sso_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continue with single sign-on`)
};

/** @type {(inputs: Signin_Sso_ButtonInputs) => LocalizedString} */
const ar_signin_sso_button = en_signin_sso_button;

/** @type {(inputs: Signin_Sso_ButtonInputs) => LocalizedString} */
const he_signin_sso_button = en_signin_sso_button;

/** @type {(inputs: Signin_Sso_ButtonInputs) => LocalizedString} */
const ur_signin_sso_button = en_signin_sso_button;

/** @type {(inputs: Signin_Sso_ButtonInputs) => LocalizedString} */
const es_signin_sso_button = en_signin_sso_button;

/** @type {(inputs: Signin_Sso_ButtonInputs) => LocalizedString} */
const fr_signin_sso_button = en_signin_sso_button;

/** @type {(inputs: Signin_Sso_ButtonInputs) => LocalizedString} */
const de_signin_sso_button = en_signin_sso_button;

/** @type {(inputs: Signin_Sso_ButtonInputs) => LocalizedString} */
const pt_signin_sso_button = en_signin_sso_button;

/** @type {(inputs: Signin_Sso_ButtonInputs) => LocalizedString} */
const hi_signin_sso_button = en_signin_sso_button;

/** @type {(inputs: Signin_Sso_ButtonInputs) => LocalizedString} */
const bn_signin_sso_button = en_signin_sso_button;

/**
* | output |
* | --- |
* | "Continue with single sign-on" |
*
* @param {Signin_Sso_ButtonInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const signin_sso_button = /** @type {((inputs?: Signin_Sso_ButtonInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signin_Sso_ButtonInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_signin_sso_button(inputs)
	if (locale === "he") return he_signin_sso_button(inputs)
	if (locale === "ur") return ur_signin_sso_button(inputs)
	if (locale === "es") return es_signin_sso_button(inputs)
	if (locale === "fr") return fr_signin_sso_button(inputs)
	if (locale === "de") return de_signin_sso_button(inputs)
	if (locale === "pt") return pt_signin_sso_button(inputs)
	if (locale === "hi") return hi_signin_sso_button(inputs)
	if (locale === "bn") return bn_signin_sso_button(inputs)
	return /** @type {LocalizedString} */ ("Continue with single sign-on")
});